import { combineReducers } from "redux";

const generateOutline = (state = {}, action) => {
    switch (action.type) {
        case "GENERATE_OUTLINE_SUCCESS":
            return {
                isLoading: false,
                isError: false,
                isSuccess: true,
                generatedImage: action.payload.image,
                uuid: action.payload.uuid,
            };
        case "CLEAR_GENERATED_OUTLINE":
            return {};
        default:
            return state;
    }
};

const fetchUserOutlines = (state = {}, action) => {
    switch (action.type) {
        case "FETCH_USER_OUTLINES_SUCCESS":
            state[action.key] = {
                isLoading: false,
                isError: false,
                isSuccess: true,
                searchOutlines: action.payload.searchResult,
                searchKey: action.payload.searchKey,
                totalSearchOutlines: action.payload.totalSearchResult,
            };
        default:
            return state;
    }
};

export default combineReducers({
    generateOutline,
    fetchUserOutlines,
});
